import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { message } from 'antd';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { resetPassword } from '../../services/services';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      message.error('Passwords do not match');
      return;
    }

    setLoading(true);

    try {
      await resetPassword({ token, password });
      message.success('Password reset successfully. You can now login with your new password.');
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Failed to reset password. The link may have expired.';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="container text-center py-5">
        <h3>Invalid Reset Link</h3>
        <p>The password reset link is invalid or has expired.</p>
        <a href="/forgot-password" className="btn btn-secondary">
          Request New Link
        </a>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Reset Password - Startup Business Partners</title>
      </Helmet>
      <Navbar />
      <br />
      <br />
      <div className="reset-password-form d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
              <div className="form-wrapper">
                <div className="card card-shadow">
                  <div className="card-header">
                    <br />
                    <h4 className="text-center">Reset Password</h4>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <input
                          type="password"
                          placeholder="New Password"
                          className="form-control"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                          minLength="6"
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          placeholder="Confirm New Password"
                          className="form-control"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                          minLength="6"
                        />
                      </div>
                      <div className="form-group text-center m-bottom-20">
                        <button
                          className="btn btn-secondary"
                          type="submit"
                          disabled={loading || success}
                        >
                          {loading ? 'Resetting...' : 'Reset Password'}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ResetPassword;